var map = {
	"./edit/copy.js": "./src/js/modules/edit/copy.js",
	"./edit/paste.js": "./src/js/modules/edit/paste.js",
	"./edit/redo.js": "./src/js/modules/edit/redo.js",
	"./edit/selection.js": "./src/js/modules/edit/selection.js",
	"./edit/undo.js": "./src/js/modules/edit/undo.js",
	"./effects/abstract/css.js": "./src/js/modules/effects/abstract/css.js",
	"./effects/black_and_white.js": "./src/js/modules/effects/black_and_white.js",
	"./effects/blueprint.js": "./src/js/modules/effects/blueprint.js",
	"./effects/borders.js": "./src/js/modules/effects/borders.js",
	"./effects/box_blur.js": "./src/js/modules/effects/box_blur.js",
	"./effects/browser.js": "./src/js/modules/effects/browser.js",
	"./effects/common/blur.js": "./src/js/modules/effects/common/blur.js",
	"./effects/common/brightness.js": "./src/js/modules/effects/common/brightness.js",
	"./effects/common/contrast.js": "./src/js/modules/effects/common/contrast.js",
	"./effects/common/grayscale.js": "./src/js/modules/effects/common/grayscale.js",
	"./effects/common/hue-rotate.js": "./src/js/modules/effects/common/hue-rotate.js",
	"./effects/common/invert.js": "./src/js/modules/effects/common/invert.js",
	"./effects/common/saturate.js": "./src/js/modules/effects/common/saturate.js",
	"./effects/common/sepia.js": "./src/js/modules/effects/common/sepia.js",
	"./effects/common/shadow.js": "./src/js/modules/effects/common/shadow.js",
	"./effects/denoise.js": "./src/js/modules/effects/denoise.js",
	"./effects/dither.js": "./src/js/modules/effects/dither.js",
	"./effects/dot_screen.js": "./src/js/modules/effects/dot_screen.js",
	"./effects/edge.js": "./src/js/modules/effects/edge.js",
	"./effects/emboss.js": "./src/js/modules/effects/emboss.js",
	"./effects/enrich.js": "./src/js/modules/effects/enrich.js",
	"./effects/grains.js": "./src/js/modules/effects/grains.js",
	"./effects/heatmap.js": "./src/js/modules/effects/heatmap.js",
	"./effects/instagram/1977.js": "./src/js/modules/effects/instagram/1977.js",
	"./effects/instagram/aden.js": "./src/js/modules/effects/instagram/aden.js",
	"./effects/instagram/clarendon.js": "./src/js/modules/effects/instagram/clarendon.js",
	"./effects/instagram/gingham.js": "./src/js/modules/effects/instagram/gingham.js",
	"./effects/instagram/inkwell.js": "./src/js/modules/effects/instagram/inkwell.js",
	"./effects/instagram/lofi.js": "./src/js/modules/effects/instagram/lofi.js",
	"./effects/instagram/toaster.js": "./src/js/modules/effects/instagram/toaster.js",
	"./effects/instagram/valencia.js": "./src/js/modules/effects/instagram/valencia.js",
	"./effects/instagram/xpro2.js": "./src/js/modules/effects/instagram/xpro2.js",
	"./effects/mosaic.js": "./src/js/modules/effects/mosaic.js",
	"./effects/night_vision.js": "./src/js/modules/effects/night_vision.js",
	"./effects/oil.js": "./src/js/modules/effects/oil.js",
	"./effects/pencil.js": "./src/js/modules/effects/pencil.js",
	"./effects/sharpen.js": "./src/js/modules/effects/sharpen.js",
	"./effects/solarize.js": "./src/js/modules/effects/solarize.js",
	"./effects/tilt_shift.js": "./src/js/modules/effects/tilt_shift.js",
	"./effects/vibrance.js": "./src/js/modules/effects/vibrance.js",
	"./effects/vignette.js": "./src/js/modules/effects/vignette.js",
	"./effects/vintage.js": "./src/js/modules/effects/vintage.js",
	"./effects/zoom_blur.js": "./src/js/modules/effects/zoom_blur.js",
	"./file/new.js": "./src/js/modules/file/new.js",
	"./file/open.js": "./src/js/modules/file/open.js",
	"./file/print.js": "./src/js/modules/file/print.js",
	"./file/quickload.js": "./src/js/modules/file/quickload.js",
	"./file/quicksave.js": "./src/js/modules/file/quicksave.js",
	"./file/save.js": "./src/js/modules/file/save.js",
	"./help/about.js": "./src/js/modules/help/about.js",
	"./help/shortcuts.js": "./src/js/modules/help/shortcuts.js",
	"./image/auto_adjust.js": "./src/js/modules/image/auto_adjust.js",
	"./image/color_corrections.js": "./src/js/modules/image/color_corrections.js",
	"./image/decrease_colors.js": "./src/js/modules/image/decrease_colors.js",
	"./image/flip.js": "./src/js/modules/image/flip.js",
	"./image/histogram.js": "./src/js/modules/image/histogram.js",
	"./image/information.js": "./src/js/modules/image/information.js",
	"./image/opacity.js": "./src/js/modules/image/opacity.js",
	"./image/palette.js": "./src/js/modules/image/palette.js",
	"./image/resize.js": "./src/js/modules/image/resize.js",
	"./image/rotate.js": "./src/js/modules/image/rotate.js",
	"./image/size.js": "./src/js/modules/image/size.js",
	"./image/translate.js": "./src/js/modules/image/translate.js",
	"./image/trim.js": "./src/js/modules/image/trim.js",
	"./layer/clear.js": "./src/js/modules/layer/clear.js",
	"./layer/composition.js": "./src/js/modules/layer/composition.js",
	"./layer/delete.js": "./src/js/modules/layer/delete.js",
	"./layer/differences.js": "./src/js/modules/layer/differences.js",
	"./layer/duplicate.js": "./src/js/modules/layer/duplicate.js",
	"./layer/flatten.js": "./src/js/modules/layer/flatten.js",
	"./layer/merge.js": "./src/js/modules/layer/merge.js",
	"./layer/move.js": "./src/js/modules/layer/move.js",
	"./layer/new.js": "./src/js/modules/layer/new.js",
	"./layer/raster.js": "./src/js/modules/layer/raster.js",
	"./layer/rename.js": "./src/js/modules/layer/rename.js",
	"./layer/visibility.js": "./src/js/modules/layer/visibility.js",
	"./tools/color_to_alpha.js": "./src/js/modules/tools/color_to_alpha.js",
	"./tools/color_zoom.js": "./src/js/modules/tools/color_zoom.js",
	"./tools/content_fill.js": "./src/js/modules/tools/content_fill.js",
	"./tools/keypoints.js": "./src/js/modules/tools/keypoints.js",
	"./tools/replace_color.js": "./src/js/modules/tools/replace_color.js",
	"./tools/restore_alpha.js": "./src/js/modules/tools/restore_alpha.js",
	"./tools/search.js": "./src/js/modules/tools/search.js",
	"./tools/settings.js": "./src/js/modules/tools/settings.js",
	"./tools/sprites.js": "./src/js/modules/tools/sprites.js",
	"./tools/translate.js": "./src/js/modules/tools/translate.js",
	"./view/full_screen.js": "./src/js/modules/view/full_screen.js",
	"./view/grid.js": "./src/js/modules/view/grid.js",
	"./view/guides.js": "./src/js/modules/view/guides.js",
	"./view/ruler.js": "./src/js/modules/view/ruler.js",
	"./view/zoom.js": "./src/js/modules/view/zoom.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/modules sync recursive \\.js$";